import Button from 'react-bootstrap/Button';
import { formButtonStyle } from '../../styles';
import { handleOptionSelect } from '../../functions';

export default function BuyRealEstate4({ setUserAnswers, navigate, location }) {
    return (
        <>
            <h2>Are you planning to sell a property as well?</h2>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "SellingQuestion", "No")
                }
            >
                No
            </Button>
            <Button
                style={formButtonStyle}
                variant="outline-primary"
                onClick={() =>
                    handleOptionSelect(navigate, location, setUserAnswers, "SellingQuestion", "Yes")
                }
            >
                Yes
            </Button>
        </>
    );
}